import React, {useRef, useState} from 'react';
import {Button, Col, Row, Spinner} from 'react-bootstrap';
import TextField from "@mui/material/TextField"
import {Checkbox} from '@material-ui/core';
import {dataURLtoFile} from '../../functions';
import Select from "react-select";
import * as pdfJS from 'pdfjs-dist';
import {getUsersData} from "../../API/user";
import {Trash2} from "react-feather";
import ProjectleaderModal from "./ProjectleaderModal";


let options = [
    {label: "Planer", value: "Planer"},
    {label: "Auftraggeber", value: "Auftraggeber"},
    {label: "Architekt", value: "Architekt"}
]

const ProjectPlanComponent =
    ({
         projectSetup, setProjectSetup, setImagePaths, setAuftraggeberList, auftraggeberList,
         auftraggeberAddress, setAuftraggeberAddress,
         projectAddress, setProjectAddress,
         planerAddress, setPlanerAddress,
         projectLeadDetails, setProjectLeadDetails
     }) => {

        const inputStyles = {
            marginTop: "1rem"
        }
        const [show, setShow] = useState(false);
        const handleClose = () => setShow(false);
        const handleShow = () => setShow(true);

        const fileInputRef = useRef(null);

        const [planDataArray, setPlanDataArray] = React.useState(projectSetup.planData);
        const [isLoading, setIsLoading] = React.useState(false);

        const [projectLeaders, setProjectLeaders] = React.useState([])
        const [newProjectLeaders, setNewProjectLeaders] = React.useState([])

        /*const [plAnrede,setplAnrede]=React.useState(projectLeadDetails.anrede)
        const [plFirstname,setplFirstname]=React.useState(projectLeadDetails.firstName)
        const [plLastname,setplLastname]=React.useState(projectLeadDetails.lastName)
        const [plEmail,setplEmail]=React.useState(projectLeadDetails.email)
        const [plTelefon,setplTelefon]=React.useState(projectLeadDetails.telefon)
    */
        const [projaddFirma, setProjaddFirma] = React.useState(projectAddress.firma)
        const [projaddStreetName, setProjaddStreetName] = React.useState(projectAddress.streetName)
        const [projaddHouseNumber, setProjaddHouseNumber] = React.useState(projectAddress.houseNumber)
        const [projaddCityName, setProjaddCityName] = React.useState(projectAddress.cityName)
        const [projaddPostalCode, setProjaddPostalCode] = React.useState(projectAddress.postalCode)
        //const [projaddEmail,setProjaddEmail]=React.useState(projectAddress.email)
        //const [projaddFax,setProjaddFax]=React.useState(projectAddress.fax)

        const [planeraddFirma, setPlaneraddFirma] = React.useState(planerAddress.firma)
        const [planeraddStreetName, setPlaneraddStreetName] = React.useState(planerAddress.streetName)
        const [planeraddHouseNumber, setPlaneraddHouseNumber] = React.useState(planerAddress.houseNumber)
        const [planeraddCityName, setPlaneraddCityName] = React.useState(planerAddress.cityName)
        const [planeraddPostalCode, setPlaneraddPostalCode] = React.useState(planerAddress.postalCode)
        const [planeraddEmail, setPlaneraddEmail] = React.useState(planerAddress.email)
        const [planeraddFax, setPlaneraddFax] = React.useState(planerAddress.fax)

        const [auftraggebberaddFirma, setAuftraggeberaddFirma] = React.useState(auftraggeberAddress.firma)
        const [auftraggeberaddStreetName, setAuftraggeberaddStreetName] = React.useState(auftraggeberAddress.streetName)
        const [auftraggeberaddHouseNumber, setAuftraggeberaddHouseNumber] = React.useState(auftraggeberAddress.houseNumber)
        const [auftraggeberaddCityName, setAuftraggeberaddCityName] = React.useState(auftraggeberAddress.cityName)
        const [auftraggeberaddPostalCode, setAuftraggeberaddPostalCode] = React.useState(auftraggeberAddress.postalCode)
        const [auftraggeberaddEmail, setAuftraggeberaddEmail] = React.useState(auftraggeberAddress.email)
        const [auftraggeberaddFax, setAuftraggeberaddFax] = React.useState(auftraggeberAddress.fax)

        React.useEffect(async () => {
            setProjectLeaders(projectLeadDetails)
            let usersdata = await getUsersData()
            let filteredusersdata=[]
            usersdata.users.forEach((user)=>{
                if(Object.values(user.r_id).includes("Bauablauf-PL")){
                    filteredusersdata.push(user)
                }
            })
            //usersdata = usersdata.filter((elem) => !projectLeadDetails.find((e ) =>
            //    (elem.fn === e.firstName && elem.ln === e.lastName && elem.em === e.email)
            //) );
            setNewProjectLeaders(filteredusersdata)

        }, [projectLeadDetails, projectLeaders])

        function getPLTableBody(plData) {
            return plData?.map((item) => (<tr key={item.input_rank}>
                <td>{item.anrede}</td>
                <td>{item.firstName}</td>
                <td>{item.lastName}</td>
                <td>{item.email}</td>
                <td>{item.telefon}</td>
                <td
                    style={{
                        textAlign: "center"
                    }}
                >
                    <button className="btn btn-danger"
                            onClick={() => handlePLDeleteChange(item.input_rank)}
                    >
                        <Trash2/>
                    </button>
                </td>
            </tr>));
        }


        React.useEffect(() => {

            let aNewPlanData = projectSetup.planData;
            setPlanDataArray(aNewPlanData);
        }, [projectSetup]);

        /*React.useEffect(()=> {
                setplAnrede(projectLeadDetails.anrede)
                setplFirstname(projectLeadDetails.firstName)
                setplLastname(projectLeadDetails.lastName)
                setplEmail(projectLeadDetails.email)
                setplTelefon(projectLeadDetails.telefon)
            },[projectLeadDetails]
        )*/

        React.useEffect(() => {
                setProjaddFirma(projectAddress.firma)
                setProjaddStreetName(projectAddress.streetName)
                setProjaddHouseNumber(projectAddress.houseNumber)
                setProjaddCityName(projectAddress.cityName)
                setProjaddPostalCode(projectAddress.postalCode)
                //setProjaddEmail(projectAddress.email)
                //setProjaddFax(projectAddress.fax)
            }, [projectAddress]
        )


        React.useEffect(() => {
                setPlaneraddFirma(planerAddress.firma)
                setPlaneraddStreetName(planerAddress.streetName)
                setPlaneraddHouseNumber(planerAddress.houseNumber)
                setPlaneraddCityName(planerAddress.cityName)
                setPlaneraddPostalCode(planerAddress.postalCode)
                setPlaneraddEmail(planerAddress.email)
                setPlaneraddFax(planerAddress.fax)
            }, [planerAddress]
        )

        React.useEffect(() => {
                setAuftraggeberaddFirma(auftraggeberAddress.firma)
                setAuftraggeberaddStreetName(auftraggeberAddress.streetName)
                setAuftraggeberaddHouseNumber(auftraggeberAddress.houseNumber)
                setAuftraggeberaddCityName(auftraggeberAddress.cityName)
                setAuftraggeberaddPostalCode(auftraggeberAddress.postalCode)
                setAuftraggeberaddEmail(auftraggeberAddress.email)
                setAuftraggeberaddFax(auftraggeberAddress.fax)
            }, [auftraggeberAddress]
        )


        React.useEffect(() => {
        }, [planDataArray]);


        const handleButtonClick = () => {

            fileInputRef.current.click();
        };


        const [isDisabled, setIsDisabled] = React.useState(false)


        React.useEffect(() => {
            if (auftraggeberList.length > 0) {
                auftraggeberList[auftraggeberList.length - 1].firstName === "" && auftraggeberList[auftraggeberList.length - 1].lastName === "" ? setIsDisabled(true) : setIsDisabled(false)
            }
        })

        const handleListAdd = () => {
            setAuftraggeberList([...auftraggeberList, {
                anrede: "-",
                fax: "-",
                firstName: "",
                lastName: "",
                input_rank: null,
                status: false,
                entscheidungsbefugnis: false,
                email: ""
            }])
        }

        /*const handleProjectleadListAdd = () => {
            setProjectLeadDetails([...projectLeadDetails, {
                anrede: "-", firstName: "", lastName: "", email: "", telefon: "", input_rank: null
            }])
        }*/

        /*const handleProjectleadInputChange = (key, event, index) => {
            const {value} = event.target
            const newInputList = [...projectLeadDetails]
            newInputList[index][key] = value
            newInputList[index].input_rank = index + 1
            setProjectLeadDetails(newInputList)
        }*/

        const handleInputChange = (key, event, index) => {
            const {value} = event.target
            const newInputList = [...auftraggeberList]
            newInputList[index][key] = value
            newInputList[index].input_rank = index + 1
            setAuftraggeberList(newInputList)
        }


        /*const handleProjectLeadDetailsInputChange = (key, event) => {
            let newInput = projectLeadDetails
            newInput[key] = event.target.value
            setProjectLeadDetails(newInput)
        }*/

        const handleProjectAddressInputChange = (key, event) => {
            let newInput = projectAddress
            newInput[key] = event.target.value
            setProjectAddress(newInput)
        }

        const handlePlanerAddressInputChange = (key, event) => {
            let newInput = planerAddress
            newInput[key] = event.target.value
            setPlanerAddress(newInput)
        }

        const handleAuftraggeberAddressInputChange = (key, event) => {
            let newInput = auftraggeberAddress
            newInput[key] = event.target.value
            setAuftraggeberAddress(newInput)
        }

        const handleRoleChange = (key, event, index) => {
            const newInputList = [...auftraggeberList]
            newInputList[index][key] = event
            newInputList[index].input_rank = index + 1
            setAuftraggeberList(newInputList)
        }

        const handleStatusChange = (key, event, index) => {

            const newInputList = [...auftraggeberList]
            newInputList[index][key] = event.target.checked
            newInputList[index].input_rank = index + 1
            setAuftraggeberList(newInputList)
        }

        const handleEntscheidungsbefugnisChange = (key, event, index) => {

            const newInputList = [...auftraggeberList]
            newInputList[index].entscheidungsbefugnis = event.target.checked
            setAuftraggeberList(newInputList)
        }

        const handleDeleteChange = async (event, id) => {

            const newInputList = [...auftraggeberList]
            newInputList.splice(newInputList.findIndex(function (i) {
                return i.input_rank === id;
            }), 1);
            setAuftraggeberList(newInputList)
        }

        const handlePLDeleteChange = async (event, id) => {
            const newInputList = [...projectLeadDetails]
            newInputList.splice(newInputList.findIndex(function (i) {
                return i.input_rank === id;
            }), 1);
            setProjectLeadDetails(newInputList)
        }

        let imageUploadAPICall = async (formData, file) => {

            /*const config = {
                //headers: {'content-type': 'multipart/form-data'}
                headers: {"Content-Type": "application/json"}

            }*/

            //let url = process.env.REACT_APP_BACKEND_API_URI + "mobileappbackendforimageupload/putimagesins3"
            let url = process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/putimagesins3modified"
            //let rslobj =  await axios.post(url, formData, config)
            let rslobj = await fetch(url, {
                method: 'POST',
                body: JSON.stringify(formData),
                headers: {"Content-Type": "application/json"}
            }).then(data => data.json())
            rslobj.presignedURL = rslobj.presignedURL.replace("http", "https")

            await fetch(rslobj.presignedURL, {
                method: 'PUT',
                body: file,
                headers: {
                    "Content-Type": "image/jpeg"
                }
            })

            return rslobj
        }


        const handleFileSelect = async (event) => {
            setIsLoading(true);
            const selectedFiles = [];
            //const pdfJS = await import('pdfjs-dist/build/pdf');
            if (!pdfJS.GlobalWorkerOptions.workerSrc) {
                pdfJS.GlobalWorkerOptions.workerSrc = window.location.origin + '/pdf.worker.min.mjs';
            }
            let imageURLs = [];
            const pdfPages = [];

            if (event.target.files.length !== 0) {
                try {
                    for (const file of event.target.files) {
                        const url = URL.createObjectURL(file);
                        if (file.type === 'application/pdf') {
                            try {
                                const response = await fetch(url);
                                const blob = await response.blob();
                                const reader = new FileReader();
                                reader.onload = async (e) => {
                                    const data = atob(e.target.result.replace(/.*base64,/, ""));
                                    const doc = await pdfJS.getDocument({data}).promise;
                                    const pages = doc.numPages;
                                    for (let index = 1; index <= pages; index++) {
                                        const page = await doc.getPage(index);
                                        pdfPages.push({name: index + file.name});
                                        const canvas = document.createElement("canvas");
                                        const context = canvas.getContext("2d");
                                        const viewport = page.getViewport({scale: 1.5});
                                        canvas.height = viewport.height;
                                        canvas.width = viewport.width;
                                        const render_context = {canvasContext: context, viewport};
                                        await page.render(render_context).promise;
                                        const img = canvas.toDataURL("image/jpg");
                                        selectedFiles.push(dataURLtoFile(img, index + file.name));
                                        imageURLs.push(URL.createObjectURL(dataURLtoFile(img, index + file.name)));
                                    }
                                    // Process the selectedFiles here after all PDF pages are processed
                                    processSelectedFiles(selectedFiles, imageURLs);
                                };
                                reader.readAsDataURL(blob);
                            } catch (error) {
                                console.error('Error converting PDFs to images:', error);
                                setIsLoading(false);
                            }
                        } else {
                            imageURLs.push(url);
                            selectedFiles.push(file);
                            await processSelectedFiles(selectedFiles, imageURLs);
                        }
                    }

                } catch (error) {
                    console.error('Error processing files:', error);
                    setIsLoading(false);
                }
            }
        };

        const processSelectedFiles = async (selectedFiles, imageURLs) => {
            let organisation = sessionStorage.getItem("org");
            let tokenValue = sessionStorage.getItem("token");
            let projectname = projectSetup.projectName;
            let formDatasForAPICalls = [];

            for (const file of selectedFiles) {
                let formData = {};
                formData.organisationID = organisation;
                formData.projectName = projectname;
                formData.token = tokenValue;
                formData.filename = file.name;
                formDatasForAPICalls.push(formData);
            }

            try {
                const values = await Promise.all(formDatasForAPICalls.map(async (formData, i) => {
                    let returnValue = await imageUploadAPICall(formData, selectedFiles[i]);
                    return returnValue.objectPath;
                }));

                setImagePaths(values);
                let planNew = [];
                imageURLs.forEach((url, index) => {
                    let x = {
                        "status": "deaktiv", "url": url, "description": "", "objectPath": values[index]
                    };
                    planNew.push(x);
                });
                let planOld = [...planDataArray];
                let planANew = [...planNew];
                let planNewArray = [...planOld, ...planANew];
                setPlanDataArray(planNewArray);
                setProjectSetup({...projectSetup, planData: planNewArray});
            } catch (error) {
                console.error('Error handling file processing:', error);
            } finally {
                setIsLoading(false);
            }
        };
        /*    const handleFileSelect = (event) => {

                const selectedFiles = event.target.files;

                let imageURLs = [];
                if (selectedFiles.length !== 0) {


                    Array.from(selectedFiles).forEach((file) => {
                        const url = URL.createObjectURL(file);
                        imageURLs.push(url);
                    });

                    let organisation = sessionStorage.getItem("org")
                    let tokenValue = sessionStorage.getItem("token")
                    let projectname = projectSetup.projectName

                    let formDatasForAPICalls = []

                    Array.from(selectedFiles).forEach(async (file) => {
                        //let formData = new FormData()
                        let formData = {}
                        /!*formData.append("picture", file)
                        formData.append("organisationID", organisation)
                        formData.append("projectName", projectname)
                        formData.append("token", tokenValue)*!/
                        //formData.picture= file
                        formData.organisationID = organisation
                        formData.projectName = projectname
                        formData.token = tokenValue
                        formData.filename = file.name
                        formDatasForAPICalls.push(formData)
                    })

                    Promise.all(formDatasForAPICalls.map(async (formData) => {
                        let returnValue = await imageUploadAPICall(formData, selectedFiles[0])
                        //return returnValue.data.objectPath
                        return returnValue.objectPath
                    })).then((values) => {
                        setImagePaths(values)

                        let planNew = [];

                        imageURLs.forEach((url, index) => {

                            let x = {
                                "status": "deaktiv", "url": url, "description": "", "objectPath": values[index]
                            }

                            planNew.push(x);

                        });


                        let planOld = [...planDataArray];

                        let planANew = planNew[0];

                        planNew = [...planOld, planANew];

                        setPlanDataArray(planNew);
                        setProjectSetup({...projectSetup, planData: planNew});

                    })


                }
            };*/

        const createPlanDataArray = (planDataArray) => {
            let planDataArrayInner = [];
            let i = 0;
            let j = 0;
            while (i < planDataArray.length) {
                let planDataArrayInnerRow = [];
                while (j < 4 && i < planDataArray.length) {
                    planDataArrayInnerRow.push(planDataArray[i]);
                    i++;
                    j++;
                }
                planDataArrayInner.push(planDataArrayInnerRow);
                j = 0;
            }

            return planDataArrayInner;

        };


        const handleCheckboxClick = (e, arrayIndex, position) => {

            let rowcolPlanDataArray = createPlanDataArray(planDataArray);
            if (rowcolPlanDataArray[arrayIndex][position].description === "") {
                alert("Bitte geben Sie eine Beschreibung ein, um den Plan zu aktivieren.");
                e.target.checked = false;
            } else {

                let prevPlanDataArray = [...planDataArray];
                prevPlanDataArray = createPlanDataArray(prevPlanDataArray);

                let rowcolPlanDataArray = prevPlanDataArray;

                if (e.target.checked) {
                    rowcolPlanDataArray[arrayIndex][position].status = 'aktiv';
                } else {
                    rowcolPlanDataArray[arrayIndex][position].status = 'deaktiv';
                }

                setPlanDataArray(rowcolPlanDataArray.flat());

            }

        };

        const getPlanDataInnerCols = (planDataArrayInner, index) => {

            let k = 0;
            let cols = [];
            let arrayIndex = index;

            if (planDataArrayInner !== undefined) {


                while (k < planDataArrayInner.length) {

                    let position = k;
                    let status = "deaktiv";
                    if (planDataArrayInner[k] !== undefined) {
                        if (planDataArrayInner[k].status !== undefined) {
                            status = planDataArrayInner[k].status;
                        }
                    }

                    cols.push(<>
                        <Col sm={3}
                             style={{height: '200px', width: '200px', justifyContent: 'center', alignItems: 'center'}}>

                            <div style={{position: 'absolute', top: '10px', left: '15px'}}>


                                <Checkbox color='grey' checked={status === "aktiv"}
                                          onClick={(e) => handleCheckboxClick(e, arrayIndex, position, status)}/>

                            </div>

                            <img src={planDataArrayInner[k]?.url} alt='plan' style={{height: '100%', width: '100%'}}/>

                            <div>
                                <textarea

                                    className="handwai-dark handwai-text-label-normal add-bottom-21-padding"

                                    style={{width: "100%", marginTop: '10px', marginBottom: '10px', resize: 'none'}}

                                    rows={2}

                                    defaultValue={planDataArrayInner[k]?.description}

                                    onChange={(e) => {

                                        let newDescription = e.target.value;

                                        let updateProjectSetup = {...projectSetup}

                                        let updateIndex = updateProjectSetup.planData.findIndex((planData) => planData.objectPath === planDataArrayInner[position].objectPath)

                                        updateProjectSetup.planData[updateIndex].description = newDescription

                                        setProjectSetup(updateProjectSetup)

                                    }}

                                />

                            </div>

                        </Col>

                    </>)

                    k++;
                }
            }

            return cols;
        }


        const planDataRender = (planDataArray) => {

            let allRowsCols = [];


            planDataArray.forEach((planDataArrayInner, index) => {


                const cols = [];
                cols.push(<>
                    {getPlanDataInnerCols(planDataArrayInner, index)}
                </>)


                allRowsCols.push(<>

                    <Row style={{marginBottom: '10px'}}>
                        {cols}
                    </Row>

                    <Row style={{height: '120px'}}>

                    </Row>
                </>)


            })

            return allRowsCols;

        }


        return (<>
            {/* Loading indicator */}
            {isLoading && (
                <div className="d-flex justify-content-center align-items-center" style={{minHeight: '100px'}}>
                    <Spinner color='
                #fff' animation="grow" style={{color: '#FFF', borderWidth: 2,}} role="status">
                        {/* <span className="visually-hidden">Loading...</span> */}
                    </Spinner>
                </div>
            )}
            <Row>

                <Col sm={1}/>
                <Col>
                    <label className='handwai-text-label-main'>Plandaten</label>
                </Col>
                <Col>

                    <div>

                        <input
                            type="file"
                            multiple
                            accept="image/*,application/pdf"
                            ref={fileInputRef}
                            onChange={handleFileSelect}
                            style={{display: 'none'}}
                        />
                        <Button className="handwai-btn-create" onClick={handleButtonClick}>+</Button>

                    </div>

                </Col>
                <Col sm={9}/>
            </Row>

            <br/>

            <Row>
                <Col sm={1}/>

                <Col>


                    {planDataRender(createPlanDataArray(planDataArray))}


                </Col>


                <Col sm={1}/>
            </Row>
            <br/>

            <Row>
                <Col sm={1}/>
                <Col sm={3}>
                    <label className='handwai-text-label-main'>Ansprechpartner beim Auftraggeber</label>
                </Col>
                <Col>

                    <div>
                        <Button className="handwai-btn-create" onClick={handleListAdd} disabled={isDisabled}>+</Button>
                    </div>

                </Col>
                <Col sm={8}/>
            </Row>
            <br/>

            <Row>
                <Col sm={1}/>
                <Col sm={11}>


                    {auftraggeberList.length > 0 ? auftraggeberList.map((input, index) => (
                        <Row key={index} style={inputStyles}
                        >
                            <Col sm={0.5}>
                                <TextField
                                    id="readOnlyField"
                                    value={index + 1}
                                    InputProps={{
                                        readOnly: true,
                                        style: {
                                            color: "white",
                                            width: 40
                                        }
                                    }}
                                />
                            </Col>
                            <Col style={{marginLeft: 10}} sm={0.5}>
                                <label className={"handwai-text-label-normal"}>{"Status:"}
                                    <Checkbox
                                        id={"status"}
                                        label={"Status"}
                                        checked={input.status}
                                        onChange={(event) => handleStatusChange("status", event, index)}
                                    />
                                </label>
                            </Col>
                            <Col sm={1}>
                                <TextField
                                    id="anrede"
                                    required
                                    label="Anrede"
                                    value={input.anrede}
                                    onChange={(event) => handleInputChange("anrede", event, index)}
                                    InputLabelProps={{
                                        style: {
                                            color: "white"
                                        }
                                    }}
                                    InputProps={{
                                        style: {
                                            color: "white", borderColor: "white"
                                        }, placeholder: "Anrede", classes: {
                                            root: "white-input", notchedOutline: "white-border"
                                        }
                                    }}
                                />
                            </Col>
                            <Col sm={1}>
                                <TextField
                                    id="firstName"
                                    required
                                    label="Vorname"
                                    value={input.firstName}
                                    onChange={(event) => handleInputChange("firstName", event, index)}
                                    InputLabelProps={{
                                        style: {
                                            color: "white"
                                        }
                                    }}
                                    InputProps={{
                                        style: {
                                            color: "white", borderColor: "white"
                                        }, placeholder: "Vorname", classes: {
                                            root: "white-input", notchedOutline: "white-border"
                                        }
                                    }}
                                />
                            </Col>
                            <Col sm={1}>
                                <TextField
                                    id="lastName"
                                    required
                                    label="Nachname"
                                    value={input.lastName}
                                    onChange={(event) => handleInputChange("lastName", event, index)}
                                    InputLabelProps={{
                                        style: {
                                            color: "white"
                                        }
                                    }}
                                    InputProps={{
                                        style: {
                                            color: "white",
                                            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "white"
                                            }
                                        }, placeholder: "Nachname", classes: {
                                            root: "white-input"
                                        }
                                    }}
                                />
                            </Col>
                            <Col sm={1}>
                                <TextField
                                    id="email"
                                    required
                                    label="E-Mail"
                                    value={input.email}
                                    onChange={(event) => handleInputChange("email", event, index)}
                                    InputLabelProps={{
                                        style: {
                                            color: "white"
                                        }
                                    }}
                                    InputProps={{
                                        style: {
                                            color: "white",
                                            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "white"
                                            }
                                        }, placeholder: "E-Mail", classes: {
                                            root: "white-input"
                                        }
                                    }}
                                />
                            </Col>
                            <span className={"handwai-text-label-normal"}>{"Entscheidungsbefugt:"}</span>
                            <Col sm={0.5}>
                                <Checkbox
                                    id={"entscheidungsbefugnis"}
                                    label={"Entscheidungsbefugnis"}
                                    checked={input.entscheidungsbefugnis}
                                    onChange={(event) => handleEntscheidungsbefugnisChange("entscheidungsbefugnis", event, index)}
                                />
                            </Col>


                            {/*<Col sm={1}>
                            <TextField
                                id="postalAddress"
                                required
                                label="PostalAddress"
                                value={input.postalAddress}
                                onChange={(event) => handleInputChange("postalAddress", event, index)}
                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "PostalAddress", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                        <Col sm={1}>
                            <TextField
                                id="fax"
                                required
                                label="Fax"
                                value={input.fax}
                                onChange={(event) => handleInputChange("fax", event, index)}
                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "Fax", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>*/}


                            <Col sm={2}>
                                <Select options={options}
                                        value={input.role}
                                        defaultValue={options[0].label}
                                        required
                                        placeholder={"Role auswählen:"}
                                        onChange={(event) => handleRoleChange("role", event, index)}
                                />
                            </Col>
                            <Col sm={1}>
                                <Button className={"btn btn-danger"}
                                        onClick={(event) => handleDeleteChange(event, input.input_rank)}> X </Button>


                            </Col>
                        </Row>)) : "kein Datei"}

                </Col>
            </Row>


            <br/>
            <br/>
            <Row>
                <Col sm={1}/>
                <Col sm={2}>
                    <label className='handwai-text-label-main'>Auftraggeber Anschrift</label>
                </Col>
                <Col sm={8}/>
            </Row>
            <Row>
                <Col sm={1}/>
                <Col sm={11}>
                    <Row style={inputStyles}
                    >
                        <Col sm={1}>
                            <TextField
                                id="auftraggeberFirma"
                                required
                                label="Firma"
                                value={auftraggebberaddFirma}
                                onChange={(event) => {
                                    setAuftraggeberaddFirma(event.target.value)
                                    handleAuftraggeberAddressInputChange("firma", event)
                                }}

                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "Firma", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                        <Col sm={1}>
                            <TextField
                                id="auftraggeberStrasse"
                                required
                                label="Str"
                                value={auftraggeberaddStreetName}
                                onChange={(event) => {
                                    setAuftraggeberaddStreetName(event.target.value)
                                    handleAuftraggeberAddressInputChange("streetName", event)
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "Str", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                        <Col sm={1}>
                            <TextField
                                id="auftraggeberHNr"
                                required
                                label="HausNr"
                                value={auftraggeberaddHouseNumber}
                                onChange={(event) => {
                                    setAuftraggeberaddHouseNumber(event.target.value)
                                    handleAuftraggeberAddressInputChange("houseNumber", event)
                                }}

                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "HausNr", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                        <Col sm={1}>
                            <TextField
                                id="auftraggeberStadt"
                                required
                                label="Stadt"
                                value={auftraggeberaddCityName}
                                onChange={(event) => {
                                    setAuftraggeberaddCityName(event.target.value)
                                    handleAuftraggeberAddressInputChange("cityName", event)
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "Stadt", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                        <Col sm={1}>
                            <TextField
                                id="auftraggeberPZahl"
                                required
                                label="Postleitzahl"
                                value={auftraggeberaddPostalCode}
                                onChange={(event) => {
                                    setAuftraggeberaddPostalCode(event.target.value)
                                    handleAuftraggeberAddressInputChange("postalCode", event)
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "Postleitzahl", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                        <Col sm={1}>
                            <TextField
                                id="auftraggeberEmail"
                                required
                                label="Email"
                                value={auftraggeberaddEmail}
                                onChange={(event) => {
                                    setAuftraggeberaddEmail(event.target.value)
                                    handleAuftraggeberAddressInputChange("email", event)
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "Email", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                        <Col sm={1}>
                            <TextField

                                id="auftraggeberFax"
                                required
                                label="Fax"
                                value={auftraggeberaddFax}
                                onChange={(event) => {
                                    setAuftraggeberaddFax(event.target.value)
                                    handleAuftraggeberAddressInputChange("fax", event)
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "Fax", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>


                    </Row>

                </Col>
            </Row>

            <br/>
            <br/>
            <Row>
                <Col sm={1}/>
                <Col sm={2}>
                    <label className='handwai-text-label-main'>Planer Anschrift</label>
                </Col>
                <Col sm={8}/>
            </Row>
            <Row>
                <Col sm={1}/>
                <Col sm={11}>
                    <Row style={inputStyles}
                    >
                        <Col sm={1}>
                            <TextField
                                style={{backgroundClip: "text"}}
                                id="planerFirma"
                                label="Firma"
                                required
                                value={planeraddFirma}
                                onChange={(event) => {
                                    setPlaneraddFirma(event.target.value)
                                    handlePlanerAddressInputChange("firma", event)
                                }}

                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "Firma", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                        <Col sm={1}>
                            <TextField
                                style={{backgroundClip: "text", col: "transparent"}}
                                id="planerStrasse"
                                required
                                label="Str"
                                value={planeraddStreetName}
                                onChange={(event) => {
                                    setPlaneraddStreetName(event.target.value)
                                    handlePlanerAddressInputChange("streetName", event)
                                }}


                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "Str", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}


                            />
                        </Col>
                        <Col sm={1}>
                            <TextField
                                id="planerHNr"
                                required
                                label="HausNr"
                                value={planeraddHouseNumber}
                                onChange={(event) => {
                                    setPlaneraddHouseNumber(event.target.value)
                                    handlePlanerAddressInputChange("houseNumber", event)
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "HausNr", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                        <Col sm={1}>
                            <TextField
                                id="planerStadt"
                                required
                                label="Stadt"
                                value={planeraddCityName}
                                onChange={(event) => {
                                    setPlaneraddCityName(event.target.value)
                                    handlePlanerAddressInputChange("cityName", event)
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "Stadt", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                        <Col sm={1}>
                            <TextField
                                id="planerPZahl"
                                required
                                label="Postleitzahl"
                                value={planeraddPostalCode}
                                onChange={(event) => {
                                    setPlaneraddPostalCode(event.target.value)
                                    handlePlanerAddressInputChange("postalCode", event)
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "Postleitzahl", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                        <Col sm={1}>
                            <TextField
                                id="planerEmail"
                                required
                                label="Email"
                                value={planeraddEmail}
                                onChange={(event) => {
                                    setPlaneraddEmail(event.target.value)
                                    handlePlanerAddressInputChange("email", event)
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "Email", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                        <Col sm={1}>
                            <TextField
                                id="planerFax"
                                required
                                label="Fax"
                                value={planeraddFax}
                                onChange={(event) => {
                                    setPlaneraddFax(event.target.value)
                                    handlePlanerAddressInputChange("fax", event)
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "Fax", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                    </Row>

                </Col>
            </Row>

            <br/>
            <br/>
            <Row>
                <Col sm={1}/>
                <Col sm={2}>
                    <label className='handwai-text-label-main'>Projekt Anschrift</label>
                </Col>
                <Col sm={8}/>
            </Row>
            <Row>
                <Col sm={1}/>
                <Col sm={11}>
                    <Row style={inputStyles}
                    >
                        <Col sm={1}>
                            <TextField
                                id="projectFirma"
                                required
                                label="Firma"
                                value={projaddFirma}
                                onChange={(event) => {
                                    setProjaddFirma(event.target.value)
                                    handleProjectAddressInputChange("firma", event)
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "Firma", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                        <Col sm={1}>
                            <TextField
                                id="projectStrasse"
                                required
                                label="Str"
                                value={projaddStreetName}
                                onChange={(event) => {
                                    setProjaddStreetName(event.target.value)
                                    handleProjectAddressInputChange("streetName", event)
                                }}

                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "Str", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                        <Col sm={1}>
                            <TextField
                                id="projectHNr"
                                required
                                label="HausNr"
                                value={projaddHouseNumber}
                                onChange={(event) => {
                                    setProjaddHouseNumber(event.target.value)
                                    handleProjectAddressInputChange("houseNumber", event)
                                }}

                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "HausNr", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                        <Col sm={1}>
                            <TextField
                                id="projectStadt"
                                required
                                label="Stadt"

                                value={projaddCityName}
                                onChange={(event) => {
                                    setProjaddCityName(event.target.value)
                                    handleProjectAddressInputChange("cityName", event)
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "Stadt", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                        <Col sm={1}>
                            <TextField
                                id="projectPZahl"
                                required
                                label="Postleitzahl"
                                value={projaddPostalCode}
                                onChange={(event) => {
                                    setProjaddPostalCode(event.target.value)
                                    handleProjectAddressInputChange("postalCode", event)
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "Postleitzahl", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>

                        {/*<Col sm={1}>
                            <TextField
                                id="projectEmail"
                                required
                                label="email"
                                value={projaddEmail}
                                onChange={(event)=>{
                                    setProjaddEmail(event.target.value)
                                    handleProjectAddressInputChange("email", event)
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "email", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                    <Col sm={1}>
                            <TextField
                                id="projectFax"
                                required
                                label="Fax"
                                value={projaddFax}
                                onChange={(event)=>{
                                    setProjaddFax(event.target.value)
                                    handleProjectAddressInputChange("fax", event)
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "Fax", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>*/}

                    </Row>

                </Col>
            </Row>

            <br/>
            <br/>
            {/*<Row>
            <Col sm={1}/>
            <Col sm={2}>
                <label className='handwai-text-label-main'>Interner Projektleiter</label>
            </Col>
            <Col sm={8}/>
        </Row>*/}
            {/*<Row>
            <Col sm={1}/>
            <Col sm={11}>
                <Row style={inputStyles}
                    >
                        <Col sm={1}>
                            <TextField
                                id="projectLeadAnrede"
                                required
                                label="Anrede"
                                value={plAnrede}
                                onChange={(event)=>{
                                    setplAnrede(event.target.value)
                                    handleProjectLeadDetailsInputChange("anrede", event)
                                }}

                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "Anrede", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                        <Col sm={1}>
                            <TextField
                                id="projectLeadFirstName"
                                required
                                label="Vorname"
                                value={plFirstname}
                                onChange={(event)=>{
                                    setplFirstname(event.target.value)
                                    handleProjectLeadDetailsInputChange("firstName", event)
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "Vorname", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                        <Col sm={1}>
                            <TextField
                                id="projectLeadNachname"
                                required
                                label="Nachname"
                                value={plLastname}
                                onChange={(event)=>{
                                    setplLastname(event.target.value)
                                    handleProjectLeadDetailsInputChange("lastName", event)
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "Nachame", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                        <Col sm={1}>
                            <TextField
                                id="projectLeadEmail"
                                required
                                label="Email"
                                value={plEmail}
                                onChange={(event)=>{
                                    setplEmail(event.target.value)
                                    handleProjectLeadDetailsInputChange("email", event)
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "email", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                        <Col sm={1}>
                            <TextField
                                id="projectLeadTelefon"
                                required
                                label="Telefon"
                                value={plTelefon}
                                onChange={(event)=>{
                                    setplTelefon(event.target.value)
                                    handleProjectLeadDetailsInputChange("telefon", event)
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: "white"
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        color: "white", borderColor: "white"
                                    }, placeholder: "Telefon", classes: {
                                        root: "white-input", notchedOutline: "white-border"
                                    }
                                }}
                            />
                        </Col>
                    </Row>

            </Col>
        </Row>*/}

            <br/>
            <br/>

            {/*<Row>
                <Col sm={1}/>
                <Col sm={3}>
                    <label className='handwai-text-label-main'>Interner Projektleiter</label>
                </Col>
                <Col>

                    <div>
                        <Button className="handwai-btn-create" onClick={handleProjectleadListAdd}
                                disabled={isDisabled}>+</Button>
                    </div>

                </Col>
                <Col sm={8}/>
            </Row>
            <br/>
            <Row>
                <Col sm={1}/>
                <Col sm={11}>


                    {projectLeadDetails.length > 0 ? projectLeadDetails.map((input, index) => (
                        <Row key={index} style={inputStyles}
                        >
                            <Col sm={0.5}>
                                <TextField
                                    id="readOnlyField"
                                    value={index + 1}
                                    InputProps={{
                                        readOnly: true,
                                        style: {
                                            color: "white",
                                            width: 40
                                        }
                                    }}
                                />
                            </Col>

                            <Col sm={1}>
                                <TextField
                                    id="anrede"
                                    required
                                    label="Anrede"
                                    value={input.anrede}
                                    onChange={(event) => handleProjectleadInputChange("anrede", event, index)}
                                    InputLabelProps={{
                                        style: {
                                            color: "white"
                                        }
                                    }}
                                    InputProps={{
                                        style: {
                                            color: "white", borderColor: "white"
                                        }, placeholder: "Anrede", classes: {
                                            root: "white-input", notchedOutline: "white-border"
                                        }
                                    }}
                                />
                            </Col>
                            <Col sm={1}>
                                <TextField
                                    id="firstName"
                                    required
                                    label="Vorname"
                                    value={input.firstName}
                                    onChange={(event) => handleProjectleadInputChange("firstName", event, index)}
                                    InputLabelProps={{
                                        style: {
                                            color: "white"
                                        }
                                    }}
                                    InputProps={{
                                        style: {
                                            color: "white", borderColor: "white"
                                        }, placeholder: "Vorname", classes: {
                                            root: "white-input", notchedOutline: "white-border"
                                        }
                                    }}
                                />
                            </Col>
                            <Col sm={1}>
                                <TextField
                                    id="lastName"
                                    required
                                    label="Nachname"
                                    value={input.lastName}
                                    onChange={(event) => handleProjectleadInputChange("lastName", event, index)}
                                    InputLabelProps={{
                                        style: {
                                            color: "white"
                                        }
                                    }}
                                    InputProps={{
                                        style: {
                                            color: "white",
                                            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "white"
                                            }
                                        }, placeholder: "Nachname", classes: {
                                            root: "white-input"
                                        }
                                    }}
                                />
                            </Col>
                            <Col sm={1}>
                                <TextField
                                    id="email"
                                    required
                                    label="E-Mail"
                                    value={input.email}
                                    onChange={(event) => handleProjectleadInputChange("email", event, index)}
                                    InputLabelProps={{
                                        style: {
                                            color: "white"
                                        }
                                    }}
                                    InputProps={{
                                        style: {
                                            color: "white",
                                            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "white"
                                            }
                                        }, placeholder: "E-Mail", classes: {
                                            root: "white-input"
                                        }
                                    }}
                                />
                            </Col>
                            <Col sm={1}>
                                <TextField
                                    id="projectLeadTelefon"
                                    required
                                    label="Telefon"
                                    value={input.telefon}
                                    onChange={(event) => {
                                        handleProjectleadInputChange("telefon", event, index)
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            color: "white"
                                        }
                                    }}
                                    InputProps={{
                                        style: {
                                            color: "white", borderColor: "white"
                                        }, placeholder: "Telefon", classes: {
                                            root: "white-input", notchedOutline: "white-border"
                                        }
                                    }}
                                />
                            </Col>
                            <Col sm={1}>
                                <Button className={"btn btn-danger"}
                                        onClick={(event) => handlePLDeleteChange(event, input.input_rank)}> X </Button>


                            </Col>
                        </Row>
                    )) : "kein Datei"}

                </Col>
            </Row>*/}

            <Row>
                <Col sm={1}/>
                <Col sm={6}>
                    <label className='handwai-text-label-main'>Interner Projektleiter</label>
                </Col>
                <Col sm={1}>

                    <div>
                        <Button className="handwai-btn-create" onClick={handleShow}>+</Button>
                    </div>

                </Col>
            </Row>

            <Row>
                <Col sm={1}/>
                <Col sm={7}>
                    <table id="projectLeadTable" className="table handwai-white-text">
                        <thead>
                        <tr>
                            <th>Anrede</th>
                            <th>Vorname</th>
                            <th>Nachname</th>
                            <th>Email</th>
                            <th>Telefon</th>
                            <th style={{width: "25%"}}
                            >Löschen
                            </th>
                        </tr>
                        </thead>
                        <tbody>{getPLTableBody(projectLeaders)}</tbody>
                    </table>
                </Col>
            </Row>

            <ProjectleaderModal show={show}
                                setShow={setShow}
                                handleClose={handleClose}
                                newProjectLeaders={newProjectLeaders}
                                projectLeadDetails={projectLeadDetails}
                                setProjectLeadDetails={setProjectLeadDetails}

            />


        </>)

    }

export default ProjectPlanComponent;

